import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Team } from './team.interface';

export const TEAM_INCLUDES = ['cluster', 'videocall_rooms'];

export class TeamService {
   async getSearchTeams(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Team>>>(`/teams`, { params: { ...query } });
      return response.data;
   }
   async getTeams(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Team>>>(`/teams`, { params: { ...query } });
      return response.data;
   }
   async updateIncomingMessagesTeam(teamId: number) {
      const response = await http.post<ApiResource<Team>>(`/teams/${teamId}/responsible-for-communications`);
      return response.data;
   }
}
